import React from 'react';
import PropTypes from 'prop-types';

export const handleChange = (e, maxLength, input) => {
  const val = e.target.value;
  if (maxLength && val.length > maxLength) {
    return;
  }
  input.onChange(e);
};

const FormNumber = (props) => {
  const {
    name, label, className, required, placeholder, min, max, maxLength, input, meta, meta: { touched, error }
  } = props;
  const errorClass = meta && touched && error ? 'form-text-error ' : '';
  return (
    <div className="form-input-container relative">
      <label htmlFor={name}>{label}</label>
      {required && <span className="form-required-text">*</span>}
      <input
        className={`${errorClass}input form-control ${className}`}
        name={name}
        type="number"
        placeholder={placeholder}
        min={min}
        max={max}
        {...input}
        onChange={e => handleChange(e, maxLength, input)}
      />
      {errorClass &&
      <span className="form-validation-message">{error}</span>
      }
    </div>
  );
};

FormNumber.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default FormNumber;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormNumber/FormNumber.js
 **/